import script from "./OfBusinessPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OfBusinessPayment.vue?vue&type=script&setup=true&lang=js"

import "./OfBusinessPayment.vue?vue&type=style&index=0&id=81335050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81335050"]])

export default __exports__